import { VideoEmbed } from "@/components/rich-editor/components/VideoEmbed.tsx";
import { parseVideoUrl } from "@/components/rich-editor/extensions/video-url.ts";
import { ButtonIcon, FontAwesomeIcon, Stack, Text } from "@skailer-com/uikit";
import { NodeViewWrapper, ReactNodeViewProps } from "@tiptap/react";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

export function BodyFileNodeView({ node, selected, deleteNode }: ReactNodeViewProps) {
  const { t } = useTranslation();
  const { src, fileName } = node.attrs as { src?: string | null; fileName: string | null };
  const isPdf = node.type.name === "pdf";
  const source = src ? parseVideoUrl(src) : null;

  return (
    <NodeViewWrapper
      data-drag-handle
      className={twMerge("relative my-2 rounded-xs", selected && "ring-2 ring-primary")}
    >
      {source ? (
        <VideoEmbed source={source} title={fileName ?? undefined} />
      ) : (
        <Stack
          direction="horizontal"
          gap="sm"
          items="center"
          className="rounded-xs bg-dark/5 p-4 pr-12"
        >
          <FontAwesomeIcon icon={isPdf ? "fa-light fa-file-pdf" : "fa-light fa-film"} />
          <Text className="truncate">{fileName ?? src}</Text>
        </Stack>
      )}
      <ButtonIcon
        variant="secondary"
        className="absolute top-2 right-2"
        title={t(isPdf ? "common:editor_pdf_remove" : "common:editor_video_remove")}
        icon={<FontAwesomeIcon icon="fa-light fa-trash" />}
        onClick={deleteNode}
      />
    </NodeViewWrapper>
  );
}
